module.exports = __webpack_public_path__ + "media/costa-rica.0253c0ad.png";